import { toQueryString } from '@suntex.core/utils';

import type * as global from '../global';

declare global {
  let GameFrame: IGameFrame;
  interface Window {
    GameFrame: IGameFrame;
  }
}

interface ThisGameFrame {
  pwaMode: boolean;
  preview: boolean;
  playerId: number;
  moduleId: number;
  moduleVariant: number;
  getProgressUrl: string;
  updateProgressUrl: string;
  loadSound: (src: string, id) => void;
  practiceMenu: any;
  changeRoundBtn: any;
  scoreboard: any;
  endScreen: any;
}

interface IGameFrame {
  autoStartTimer: boolean;
  TEST: boolean;
  _instance: any;
  _onTick: any;
  _interactionLogged: any;
  _logInteraction: any;
  _interactionTimer: any;
  _initButton: any;
  _playNextGame: any;
  _navigateMoreGames: any;
  _clickChangeRounds: any;
  _clickRoundBtn: any;
  _onRoundButtonOver: any;
  _onRoundButtonOut: any;
}

export function extendGameFrame() {
  if (lib.comsuntexsymbolsGameFrame) {
    window.GameFrame = lib.comsuntexsymbolsGameFrame as IGameFrame;

    //by default, start the timer on gameStart
    //(but let individual games override this, if they know better)
    GameFrame.autoStartTimer = true;

    const comsuntexsymbolsGameFrame_constructor = lib.comsuntexsymbolsGameFrame;
    const comsuntexsymbolsGameFrame_prototype =
      lib.comsuntexsymbolsGameFrame.prototype;

    lib.comsuntexsymbolsGameFrame = function () {
      GameFrame._instance = this;
      this._oldConstructor = comsuntexsymbolsGameFrame_constructor;
      this._oldConstructor();
    };

    lib.comsuntexsymbolsGameFrame.prototype =
      comsuntexsymbolsGameFrame_prototype;

    GameFrame._onTick = function () {
      if (GameFrame._interactionLogged) {
        GameFrame._instance.timeOnTask += 30;
        GameFrame._interactionLogged = false;
      }
    };

    GameFrame._logInteraction = function (e) {
      GameFrame._interactionLogged = true;
    };

    GameFrame._interactionTimer = new Timer(30000, GameFrame._onTick);
    GameFrame._interactionLogged = false;

    const p = lib.comsuntexsymbolsGameFrame.prototype;

    p.init = function (this: ThisGameFrame, stage) {
      UIUtil.setStage(stage);
      this.loadSound('beep.mp3', 'gameframe-click');
      this.loadSound('whoosh.mp3', 'gameframe-whoosh');
      this.loadSound('powerup.mp3', 'gameframe-powerup');

      if (GameFrame.TEST) {
        TestUtil.SHOW_WARNINGS = true;
      } else {
        this.playerId = UIUtil.getParamAsInt('playerId');
        this.moduleId = UIUtil.getParamAsInt('moduleId');
        this.preview = UIUtil.getParamAsBool('preview');
        this.pwaMode = UIUtil.getParamAsBool('pwaMode');
        this.moduleVariant = UIUtil.getParamAsInt('moduleVariant');
        if (UIUtil.getParam('getProgressUrl') != null)
          this.getProgressUrl = UIUtil.getParam('getProgressUrl');
        if (UIUtil.getParam('updateProgressUrl') != null)
          this.updateProgressUrl = UIUtil.getParam('updateProgressUrl');
        TestUtil.SHOW_WARNINGS = false;
        if (UIUtil.getParamAsBool('soundDisabled')) this.scoreboard.mute();
      }

      GameFrame._initButton(this.endScreen.nextBtn, GameFrame._playNextGame);
      GameFrame._initButton(
        this.endScreen.moreBtn,
        GameFrame._navigateMoreGames,
      );
      GameFrame._initButton(
        this.practiceMenu.moreBtn,
        GameFrame._navigateMoreGames,
      );

      UIUtil.createSimpleButton(
        this.changeRoundBtn,
        GameFrame._clickChangeRounds,
      );

      stage.addEventListener('stagemousedown', GameFrame._logInteraction);
    };

    p.moduleId = 0;
    p.moduleVariant = 0;

    p.gameStartFunction = null;
    p.gameStopFunction = null;
    p.loadedVars = null;

    // Loading
    p.getProgressUrl = '/api/player/get-progress';
    p.gameDataFormat = LoadUtil.JSON;
    p.gameDataObject = null;
    p.updateProgressUrl = '/api/player/update-progress';

    p.pwaMode = false;

    p.playerId = 0;
    p.preview = false;
    p.round = 1;
    p.game = 1;
    p.score = 0;
    p.scoreMax = 360;
    p.bonus = 0;
    p.timeOnTask = 0;

    p.roundsInModule = 4;
    p.gamesPerRound = 15;
    p.bonusMax = -1;

    p.disableMoreBtn = false;
    p.disableNextBtn = false;

    // interface options
    p.automateScoreboard = true;
    p.displayProgress = true;
    p.displayPoints = false;
    p.automateDatabaseUpdates = true;
    p.soundDirectory = fimCdnUrl('/sounds/');

    p.initGame = function (gameStartFunction, gameStopFunction) {
      this.gameStartFunction = () => {
        if (gameStartFunction) gameStartFunction();

        //if automatically starting the timer on game start, start it
        if (GameFrame.autoStartTimer) window.startTimeOnTask();
      };

      this.gameStopFunction = () => {
        window.stopTimeOnTask();

        if (gameStopFunction) gameStopFunction();
      };

      UIUtil.hide(this.endScreen);
      UIUtil.hide(this.changeRoundBtn);
      this.scoreboard.hideProgressPanel();

      for (let i = 1; i <= 4; i++) {
        const btn = this.practiceMenu['round' + i + 'Btn'];
        if (i <= this.roundsInModule) {
          GameFrame._initButton(btn, GameFrame._clickRoundBtn, i);
          btn.x += (4 - this.roundsInModule) * 50;
        } else {
          UIUtil.hide(btn);
        }
      }

      TestUtil.log('PWA:' + this.pwaMode);

      if (this.preview) {
        UIUtil.hide(this.veil);
      } else {
        if (this.gameDataObject != null) {
          this._onVarsLoad(this.gameDataObject);
        } else {
          const vars = {
            playerId: this.playerId,
            moduleId: this.moduleId,
            moduleVariant: this.moduleVariant,
          } satisfies apiPlayer.GetProgress.Request;

          if (GameFrame.TEST)
            LoadUtil.get(
              this.getProgressUrl,
              this._onVarsLoad,
              this.gameDataFormat,
              this,
            );
          else if (this.pwaMode) {
            TestUtil.log('isPWAMode');

            fimGameRepository.Games.getProgress(vars)
              .then((values) => this._onVarsLoad(values))
              .catch((values) => this._onVarsLoad(values));
          } else
            LoadUtil.get(
              `${this.getProgressUrl}?${toQueryString(vars)}`,
              this._onVarsLoad,
              this.gameDataFormat,
              this,
            );
        }
      }
    };

    p.startGame = function () {
      this.score = 0;
      this.bonus = 0;
      this.timeOnTask = 0;
      if (this.automateScoreboard) this.updateScoreboard();
      this.scoreboard.showProgressPanel();
      UIUtil.hide(this.endScreen, 500);
      GameFrame._interactionTimer.start();
      this.gameStartFunction();

      //	//start timing, but in a callback, to let the timer initialize
      //	setTimeout(() => window.startTimeOnTask(), 100);
    };

    p.endGame = function () {
      GameFrame._interactionTimer.stop();

      this.bonus = Math.round(this.bonus + 0.4);

      if (this.gameStopFunction != null) this.gameStopFunction();
      if (this.automateDatabaseUpdates) this.updateDatabase();
      let message = '';
      UIUtil.show(this.endScreen.stickersText);
      if (!this.preview) {
        UIUtil.hide(this.endScreen.nextBtn);
        UIUtil.hide(this.endScreen.moreBtn);
      } else {
        if (this.disableMoreBtn) {
          UIUtil.show(this.practiceMenu.moreBtn, 500);
        } else {
          UIUtil.hide(this.practiceMenu.moreBtn);
        }
      }
      if (this.displayPoints) {
        if (this.score < 50) {
          // Was 15?
          message = Chance.selectRandom([
            'Keep trying!',
            "Don't give up!",
            'Give it another try.',
            'Keep practicing!',
          ]);
          this.endScreen.beforeScoreText.text = 'You only scored';
          this.endScreen.afterScoreText.text = 'points this time.';
        } else if (this.score < 150) {
          message = Chance.selectRandom([
            'Not bad!',
            'Good work.',
            'Keep it up!',
            'Keep practicing!',
          ]);
          this.endScreen.beforeScoreText.text = 'You scored';
          this.endScreen.afterScoreText.text = 'points.';
        } else if (this.score < 300) {
          message = Chance.selectRandom([
            'Congratulations!',
            'Wow!',
            'Great job!',
            'Excellent!',
            'Well done!',
          ]);
          this.endScreen.beforeScoreText.text = 'You scored';
          this.endScreen.afterScoreText.text = 'points!';
        } else {
          message = Chance.selectRandom([
            'Fantastic!',
            'Outstanding!',
            'Amazing!',
            'Superb!',
          ]);
          this.endScreen.beforeScoreText.text = 'You scored';
          this.endScreen.afterScoreText.text = 'points!!';
        }
        this.endScreen.pointsText.text = this.score;
      } else {
        this.endScreen.beforeScoreText.text = '';
        this.endScreen.pointsText.text = '';
        this.endScreen.afterScoreText.text = '';
        if (this.score == 0) {
          this.endScreen.stickersText.text = '';
          this.endScreen.beforeScoreText.text = '';
          this.endScreen.afterScoreText.text = '0 Stickers';
          message = Chance.selectRandom([
            'Keep trying!',
            "Don't give up!",
            'Give it another try.',
            'Keep practicing!',
          ]);
        } else if (this.score >= 1 && this.score <= 5) {
          this.endScreen.beforeScoreText.text = '';
          message = Chance.selectRandom([
            'Not bad!',
            'Good work.',
            'Keep it up!',
            'Keep practicing!',
          ]);
        } else {
          this.endScreen.afterScoreText.text = Chance.selectRandom([
            'You won!',
            'You did it!',
            'You got it right!',
          ]);
          message = Chance.selectRandom([
            'Fantastic!',
            'Outstanding!',
            'Great job!',
            'Excellent!',
            'Well done!',
            'Nice Work!',
          ]);
        }
      }
      if (this.game == this.gamesPerRound) {
        message = 'You finished this round!';
        LoadUtil.playSound('gameframe-powerup');
      }
      this.endScreen.messageText.text = message;

      UIUtil.enable(this.endScreen);
      UIUtil.show(this.endScreen, 500);
      //UIUtil.scaleTo( this.endScreen.watermark, .1 );
      //UIUtil.fadeTo( this.endScreen.watermark, 0.0 );
      if (this.score > 15)
        UIUtil.delay(this._endGameAnimation, 500, null, this);
    };

    p._endGameAnimation = function () {
      //UIUtil.scaleTo( this.endScreen.watermark, 1.0, 2000, "elasticOut" );
      //UIUtil.fadeTo( this.endScreen.watermark, 1.0, 500 );
    };

    /* Score */

    p.finished = function () {
      return this.score >= this.scoreMax;
    };

    p.updateScoreboard = function () {
      this.scoreboard.updateRound(this.round);
      this.scoreboard.updateGame(this.game);
      this.scoreboard.updateProgress(this.score / this.scoreMax);
    };

    p.incrementScore = function (scoreIncrement) {
      scoreIncrement = Calculator.getInt(scoreIncrement, 1);
      this.setScore(this.score + scoreIncrement);
    };

    p.setScore = function (score) {
      this.score = score;
      this.score = Calculator.bound(this.score, 0, this.scoreMax);
      if (this.automateScoreboard) this.updateScoreboard();
    };

    p.incrementBonus = function (bonusIncrement) {
      this.bonus += bonusIncrement;
      if (this.bonusMax > 0 && this.bonus > this.bonusMax)
        this.bonus = this.bonusMax;
      this.scoreboard.updateBonus('' + this.bonus);
    };

    p.getLevel = function () {
      return Math.floor((6 * this.score) / this.scoreMax) + 1;
    };

    /* Data */

    p.getVar = function (key) {
      if (this.loadedVars != null && this.loadedVars[key] != null)
        return this.loadedVars[key];
      else return '';
    };

    p.setGameData = function (vars) {
      this.gameDataObject = vars;
    };

    p._onVarsLoad = function (vars: apiPlayer.GetProgress.Response) {
      this.loadedVars = vars;

      if (vars != null) {
        this.round = Calculator.getInt(vars.round);
        this.game = Calculator.getInt(vars.game);
        this.extendedData = this.getVar('extendedData');
        if (
          vars.finishedEarning ||
          this.round < 1 ||
          this.playerId < 1 ||
          !Calculator.isDefined(this.playerId) ||
          this.game > this.gamesPerRound ||
          this.round > this.roundsInModule
        )
          this.preview = true;

        if (this.preview) {
          GameFrame._clickChangeRounds(null);
        } else {
          UIUtil.hide(this.practiceMenu);
          this.startGame();
        }
      } else {
        this.preview = true;
      }

      UIUtil.hide(this.veil);
    };

    p.nextGame = function () {
      UIUtil.disable(this.endScreen);

      if (this.preview || GameFrame.TEST) {
        if (this.game < this.gamesPerRound) {
          this.game++;
        } else {
          this.game = 1;
          this.round++;
          if (this.round > this.roundsInModule) {
            this.round = 0;
          }
        }

        if (this.round > 0) {
          this.startGame();
        } else {
          GameFrame._clickChangeRounds(null);
        }
      } else {
        const vars = {
          playerId: this.playerId,
          moduleId: this.moduleId,
          moduleVariant: this.moduleVariant,
        } satisfies apiPlayer.GetProgress.Request;

        if (this.pwaMode) {
          TestUtil.log('isPWAMode');

          fimGameRepository.Games.getProgress(vars)
            .then((values) => this._onVarsLoad(values))
            .catch((values) => this._onVarsLoad(values));
        } else {
          LoadUtil.get(
            `${this.getProgressUrl}?${toQueryString(vars)}`,
            this._onVarsLoad,
            this.gameDataFormat,
            this,
          );
        }
      }
    };

    p.updateDatabase = function (advanceProgress = true) {
      //TODO: don't think we need this anymore, since the default is in the param
      if (!Calculator.isDefined(advanceProgress)) advanceProgress = true;

      const vars = {} as apiPlayer.UpdateProgress.Request;
      vars.playerId = this.playerId;
      vars.moduleId = this.moduleId;
      vars.moduleVariant = this.moduleVariant;
      vars.round = this.round;
      vars.game = this.game;
      vars.score = this.score;
      vars.bonus = this.bonus;
      vars.extendedData = this.extendedData;
      vars.timeOnTask = this.timeOnTask;
      vars.advanceProgress = advanceProgress;

      //get the salt and then call the method with that name
      //note: here using the obscure fact that window.saltvalue has been
      //preloaded with the magic hash function
      const salt = window.salter();
      window[salt](vars);

      if (GameFrame.TEST) {
        LoadUtil.post(
          'this.updateProgressUrl',
          null,
          this._onDatabasePost,
          LoadUtil.JSON,
          this,
        );
        TestUtil.log('updateDatabase()::' + vars);
      } else if (this.pwaMode) {
        TestUtil.log('isPWAMode');
        fimGameRepository.Games.updateProgress(vars).then((result) =>
          this._onDatabasePost(result),
        );
      } else {
        if (!this.preview) {
          LoadUtil.post(
            this.updateProgressUrl,
            vars,
            this._onDatabasePost,
            LoadUtil.JSON,
            this,
          );
        }

        //post TOT
        window.postTimeOnTaskByStatus(this.preview, advanceProgress);
      }

      this.timeOnTask = 0;
    };

    p.resetRoundProgress = function () {
      this.game = 0;
      this.updateDatabase();
    };

    p._onDatabasePost = function (result) {
      this.endScreen.stickersText.text = '';
      if (result != null) {
        const stickers = Calculator.getInt(result.stickers, 0);
        if (!this.disableNextBtn) {
          UIUtil.show(this.endScreen.nextBtn, 500);
        }
        if (!this.disableMoreBtn) {
          UIUtil.show(this.endScreen.moreBtn, 500);
        }
        if (stickers > 0) {
          this.endScreen.stickersText.text =
            'You earned ' +
            stickers +
            (stickers > 1 ? ' stickers' : ' sticker');
          UIUtil.show(this.endScreen.stickersText, 500);
        }
      }
    };

    /* Main Menu */

    GameFrame._initButton = function (btn, onClick, value) {
      UIUtil.createButton(
        btn,
        onClick,
        value,
        GameFrame._onRoundButtonOver,
        GameFrame._onRoundButtonOut,
      );
      UIUtil.hide(btn.btnHover);
    };

    GameFrame._clickChangeRounds = function (e) {
      LoadUtil.playSoundAtVolume('whoosh', 0.5);
      if (GameFrame._instance.gameStopFunction != null)
        GameFrame._instance.gameStopFunction();
      UIUtil.show(GameFrame._instance.practiceMenu, 500);
      UIUtil.hide(GameFrame._instance.changeRoundBtn);
      GameFrame._instance.scoreboard.hideProgressPanel();
    };

    GameFrame._clickRoundBtn = function (e) {
      LoadUtil.playSoundAtVolume('click', 0.5);
      const btn = UIUtil.getEventTarget<{ value: number }>(e);
      GameFrame._instance.round = btn.value;
      GameFrame._instance.game = 1;
      UIUtil.show(GameFrame._instance.changeRoundBtn);
      UIUtil.hide(GameFrame._instance.practiceMenu, 500);

      GameFrame._instance.startGame();
    };

    GameFrame._onRoundButtonOver = function (e) {
      const btn = UIUtil.getEventTarget<{ bg: createjs.MovieClip }>(e);
      UIUtil.setFrame(btn.bg, 2);
    };

    GameFrame._onRoundButtonOut = function (e) {
      const btn = UIUtil.getEventTarget<{ bg: createjs.MovieClip }>(e);
      UIUtil.setFrame(btn.bg, 1);
    };

    GameFrame._playNextGame = function (e) {
      LoadUtil.playSoundAtVolume('gameframe-click', 0.5);
      GameFrame._instance.nextGame();
    };

    GameFrame._navigateMoreGames = function (e) {
      const hubUrl = UIUtil.getParam('hubUrl') || '';

      LoadUtil.playSoundAtVolume('click', 0.5);

      if (GameFrame.TEST) {
        TestUtil.log(`UIUtil.navigate('${hubUrl}')`);
      } else {
        UIUtil.navigate(hubUrl);
      }
    };

    /* Misc */

    p.setBackgroundLoop = function (src) {
      //TODO: Revisit how to load sound files based on local vs hosted protype vs site integrated vs working offline like in a PWA.
      //var soundDirectory = GameFrame.TEST ? "sounds/loops/" : fimCdnUrl("/sounds/loops/");
      const soundDirectory = fimCdnUrl('/sounds/loops/');
      LoadUtil.startLoop(soundDirectory + src);
    };

    p.loadSound = function (src, id) {
      //TODO: Revisit how to load sound files based on local vs hosted protype vs site integrated vs working offline like in a PWA.
      //var soundDirectory = GameFrame.TEST ? "sounds/" : fimCdnUrl("/sounds/");
      const soundDirectory = fimCdnUrl('/sounds/');
      LoadUtil.loadSound(soundDirectory + src, id);
    };

    p.mute = function () {
      this.scoreboard.mute();
    };

    GameFrame.TEST = false;
  }
}
